import dayjs from 'dayjs'
import relativeTimePlugin from 'dayjs/plugin/relativeTime'
import utcPlugin from 'dayjs/plugin/utc'
import advancedFormat from 'dayjs/plugin/advancedFormat'

dayjs.extend(relativeTimePlugin)
dayjs.extend(utcPlugin)
dayjs.extend(advancedFormat)

export const toUtc = (date) => {
  return dayjs(date).utc(date)
}

export const ago = (date, noSuffix = false, utc = false) => {
  const d = utc ? toUtc(date) : dayjs(date)
  return d.fromNow(noSuffix)
}

export const isValid = (date) => {
  return dayjs(date).isValid()
}

export const format = (date, template) => {
  return dayjs(date).format(template)
}

export const dateAndMonth = (date) => {
  return dayjs(date).format('Do MMM')
}

export const isAfter = (date, noOfDays) => {
  return dayjs(date).isAfter(dayjs().subtract(noOfDays, 'day'))
}

export const formatRelativeDate = (date, noOfDays) => {
  if (dayjs(date).isBefore(dayjs().subtract(1, 'year'))) {
    return dayjs(date).format('DD MMM, YYYY')
  } else if (isAfter(date, noOfDays)) {
    return ago(date)
  } else {
    return dateAndMonth(date)
  }
}

export const formatLongDateTime = (date) => {
  return dayjs(date).format('DD MMM YYYY, hh:mm A')
}
